import React, { FCWithChildren, ReactElement, ReactNode } from 'react';

interface ConditionalWrapperProps {
  condition: boolean;
  wrap: (children: ReactNode) => ReactElement;
}

const ConditionalWrapper: FCWithChildren<ConditionalWrapperProps> = ({ condition, wrap, children }): ReactElement =>
  condition ? wrap(children) : <>{children}</>;

export default ConditionalWrapper;
